import React from 'react'

const fmt = (n) => {
    if (n === null || n === undefined || Number.isNaN(n)) return '—'
    return Number(Number(n).toFixed(3)).toString()
}

const Metric = ({ value }) => (
    <>
        <span className="bhpCurrent">{fmt(value?.current)}</span>
        <span className="bhpDesign"> / {fmt(value?.design)}</span>
    </>
)

// shortLabel replaces the label on mobile
const Kpi = ({ label, shortLabel, value, unit, design }) => (
    <div className="bhpKpi">
        <div className="bhpKpiLabel">
            {
                shortLabel
                    ? (
                        <>
                            <span className="bhpKpiLabelFull">{label}</span>
                            <span className="bhpKpiLabelShort">{shortLabel}</span>
                        </>
                    )
                    : label
            }
        </div>
        <div className="bhpKpiValue">
            {value}<span className="bhpKpiUnit"> {unit}</span>
        </div>
        {design !== undefined && <div className="bhpKpiDesign">design {design}</div>}
    </div>
)

const Head = ({ label, unit, left }) => (
    <th className={left ? 'bhpLeft' : undefined}>
        <div className="bhpHeadLabel">{label}</div>
        {unit && <div className="bhpHeadUnit">{unit}</div>}
    </th>
)

const BhpPumpingScheduleTable = ({ steps = [] }) => {
    if (!steps.length) {
        return <div className="bhpEmpty">Waiting for pumping schedule data…</div>
    }

    const first = steps[0]
    const active = steps.find(st => st.isActive) || steps[steps.length - 1]
    const unit = first.slurryTotal?.unit || 'm³'
    const remaining = Math.max((active.slurryTotal?.design || 0) - (active.slurryTotal?.current || 0), 0)

    return (
        <>
        <div className="bhpHero" style={{ '--step-color': active.color }}>
            <div className="bhpHeroStep">
                <div className="bhpKpiLabel">Now pumping</div>
                <div className="bhpHeroTitle">
                    <span className="bhpStepDot" />Step {active.step} of {steps.length}
                </div>
                <div className="bhpProppant">
                    {[active.name || active.fluidName, active.proppantName !== '-' && active.proppantName].filter(Boolean).join(' · ')}
                </div>
            </div>
            <Kpi label="Step remaining" value={fmt(remaining)} unit={unit} />
            <Kpi label="Flow rate" value={fmt(active.flowRate?.current)} unit={active.flowRate?.unit} design={fmt(active.flowRate?.design)} />
            <Kpi label="Proppant concentration" shortLabel="Proppant conc." value={fmt(active.proppantConcentration?.current)} unit={active.proppantConcentration?.unit} design={fmt(active.proppantConcentration?.design)} />
        </div>

        <div className="bhpTableWrap">
        <table className="bhpTable">
            <thead>
                <tr>
                    <Head left label="Step" />
                    <Head left label="Fluid" />
                    <Head left label="Progress" />
                    <Head label="Slurry total" unit={`${first.slurryTotal?.unit || 'm³'} · current / design`} />
                    <Head label="Flow rate" unit={`${first.flowRate?.unit || 'm³/min'} · current / design`} />
                    <Head label="Proppant concentration" unit={`${first.proppantConcentration?.unit || 'kg/l'} · current / design`} />
                </tr>
            </thead>
            <tbody>
                {
                    steps.map(s => {
                        const pct = Math.round(Math.max(s.progress || 0, 0) * 100)
                        const isOver = pct > 100
                        const cls = s.isActive ? 'bhpActiveRow' : (s.isCompleted ? 'bhpDoneRow' : 'bhpPendingRow')
                        return (
                            <tr key={s.step} className={cls} style={{ '--step-color': s.color }}>
                                <td className="bhpLeft"><span className="bhpStepNum">{s.step}</span></td>
                                <td className="bhpLeft">
                                    <div className="bhpFluid">{s.name || s.fluidName || '—'}</div>
                                    {s.proppantName && s.proppantName !== '-' && <div className="bhpProppant">{s.proppantName}</div>}
                                </td>
                                <td className="bhpLeft bhpProgressCol">
                                    <div className={`bhpProgressWrap${isOver ? ' bhpProgressWrap--over' : ''}`}>
                                        <div className="bhpProgressTrack">
                                            <div className="bhpProgressFill" style={{ width: `${Math.min(pct, 100)}%` }} />
                                        </div>
                                        <span className="bhpProgressPct">{pct}%</span>
                                    </div>
                                </td>
                                <td><Metric value={s.slurryTotal} /></td>
                                <td><Metric value={s.flowRate} /></td>
                                <td><Metric value={s.proppantConcentration} /></td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
        </div>
        </>
    )
}

export default BhpPumpingScheduleTable
